import QRCode from 'react-qr-code';
import {BUSINESS_NAME} from "@/content";

export type QRGeneratorProps = {
    value?: string;
    size?: string;
    fgColor?: string;
    bgColor?: string;
}

export const QRGenerator = ({value, size = '400px', bgColor = 'white', fgColor = 'black'}: QRGeneratorProps) => {



    const backgroundStyle = {
        display: 'flex',
        width: '100%',
        flexDirection: 'column'
    }

    const qrStyle = {
        padding: '40px',
        backgroundColor: 'white',
        border: '2px solid #efefef',
        margin: '40px auto',
        width: size,
        height: size,
    }

    return (
        <div style={backgroundStyle}>
            <QRCode
                title={BUSINESS_NAME}
                value={value || 'https://bigbitemedia.com.au'}
                bgColor={bgColor}
                fgColor={fgColor}
                style={qrStyle}
                // size={size === '' ? 0 : size}
            />

        </div>
    )
}
